import React from 'react'

import CleanupContent from 'sen/components/pages/cleanup/content/CleanupContent'
import sentintelContentLoader from 'sen/components/lib/useSentinelContentCondition/SentinelContentLoader'

export default sentintelContentLoader({
  default: () => <CleanupContent data-field="cleanup-content" />
})
